<template>
  <div class="container">
    <div class="countdown-wrap" >
      <ul>
        <li :style='{"color":color}'>{{day}}</li>
        <li class="gap">:</li>
        <li :style='{"color":color}'>{{hour}}</li>
        <li class="gap">:</li>
        <li :style='{"color":color}'>{{min}}</li>
        <li class="gap">:</li>
        <li :style='{"color":color}'>{{sec}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['reload'],
  props: ['images', 'activityType', 'startTime', 'endTime', 'color'],
  data() {
    return {
      day: '00',
      hour: '00',
      min: '00',
      sec: '00',
      timer: null,
      targetTime: '',
    }
  },
  watch: {
    startTime(value) {
      if (this.activityType === 101 || this.activityType === 71) {
        this.targetTime = value * 1000
      }
    },
    endTime(value) {
      if (this.activityType !== 101 || this.activityType !== 71) {
        this.targetTime = value * 1000
      }
    },
  },
  created() {
    if (this.activityType === 101 || this.activityType === 71) {
      this.targetTime = this.startTime * 1000
    } else {
      this.targetTime = this.endTime * 1000
    }
    if (this.targetTime - Date.now() <= 0) {
      return
    }
    this.timer = setInterval(this.fnCountdown, 1000)
  },
  methods: {
    fnCountdown() {
      // 获取当前时间
      const _now = Date.now()
      // 计算差值
      const _offset = Math.floor((this.targetTime - _now) / 1000)

      if (_offset <= 0) {
        // 清除定时器
        clearInterval(this.timer)
        this.refresh() // 刷新页面
      }

      this.sec = _offset % 60
      this.min = Math.floor(_offset / 60) % 60
      this.hour = Math.floor(_offset / 60 / 60) % 24
      this.day = Math.floor(_offset / 60 / 60 / 24)

      this.sec = this.sec < 10 ? '0' + this.sec : this.sec
      this.min = this.min < 10 ? '0' + this.min : this.min
      this.hour = this.hour < 10 ? '0' + this.hour : this.hour
      this.day = this.day < 10 ? '0' + this.day : this.day
    },
    refresh() {
      this.reload()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.countdown-wrap {
  display: flex;
  justify-content: center;
}
.countdown-wrap ul {
  display: flex;
  align-items: center;
  font-size: 0.32rem;
  color: white;
}
.countdown-wrap ul li:not(.gap) {
  font-size: 0.2rem;
  width: 0.36rem;
  height: 0.36rem;
  color: #ED2856;
  background-color: white;
  border-radius: 0.04rem;
  text-align: center;
  line-height: 0.36rem;
}
.countdown-wrap ul li.gap{
  width: 0.2rem;
  text-align: center;
}
</style>
